<template>
<div class="pa" v-bind:class="dataType">
    <div class="button-trigger" v-if="dataType === 'emailStyle'">
       <button class="btn waves-effect btn-flat transparent trigger"
        @click="$_expandMe()">
        <i class="material-icons grey-text text-darken-3 left" v-if="instanceStatus === 'closed'">expand_more</i>
        <i class="material-icons grey-text text-darken-3 left" v-else>expand_less</i>
          <slot name="button"> </slot>
       </button>
    </div>
    <ul class="collapsible expandable " v-bind:class="classes" ref="colapsEl">
    <li :class="[isActive ? 'active' : '']">
<!-- <div class="overHeader white">
        <slot name="overheader"></slot>
      </div> -->
      <div class="collapsible-header" v-show="dataType === 'normal'">
        <slot name="header" ></slot>
        <div class="show-state" v-if="showState" style="position:absolute; right: 24px;">
        <i class="material-icons grey-text text-darken-3 left off">expand_more</i>
        <i class="material-icons grey-text text-darken-3 left on">expand_less</i>
        </div>
      </div>
      <div class="collapsible-body">
        <slot name="body"></slot>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import M from 'materialize-css'
export default {
name:'collapsibleComponent',
props:{
  classes:{
    type:String,
    default:'default'
  },
  isActive:{
    type: Boolean,
    default:false,
  },
  showState:{
    type: Boolean,
    default:false
  },
  dataIndex:{
    type:Number,
    default:1,
  },
  dataType:{
    type:String,
    default:'normal'
  }
},
data(){
  let vm = this
  return {
    options:{
      onOpenStart:()=>{
        vm.$emit('status','startedOpening')
      }
    },
    instanceStatus:'closed',
    instance:null,
  }
},
mounted(){
setTimeout(() => {
    this.$_initComponent()
}, 600);
  
},
methods:{
  $_initComponent(){
    let ele = this.$el.querySelector('.collapsible')
    this.instance =  M.Collapsible.init(ele, this.options);
  },
  $_statState (){ 

  },
  $_expandMe(){
    setTimeout(() => { }, 50);
    this.instanceStatus === 'closed'
     ? this.instance.open()
     : this.instance.close()
   
    this.instanceStatus === 'closed'
    ? this.instanceStatus = 'open'
    : this.instanceStatus = 'closed'
    
  }
}
}
</script>

<style lang="scss" scoped>

.overHeader {
  position: relative;
}
.pa {
  width: 100%
}
.collapsible {
  border:none !important;
  border-radius:4px;
  overflow: hidden;
}

.emailStyle {
  .collapsible {
    box-shadow: none; background: transparent; border:none;
    .collapsible-body {
      padding:0px;
    }
  }
 
}
</style>
<style lang="scss">
.small-body-padding {
  .collapsible-body {
    padding: 16px !important;
    background: white;
  }
}
li {
    i.on {
      opacity: 0;
      display: none;
    }
    i.off {
      opacity: 1;
      display: inherit;
    }
  &.active {
    .collapsible-header {
      .show-state {
        .on {
          opacity: 1;
          display: inherit;
        }
        .off {
          opacity: 0;
          display: none;
        }
      }
    }
  }
}
.special {
  .collapsible-header {
    position: absolute;
    right: 16px;
    top: 16px;
    height: 33px;
    border: none;
    padding: 0px;
    line-height: 38px !important; 
    i {
      margin: 0px;
      font-size: 24px;
      line-height: 34px !important;
    }
  }
}
.overHeader {
  height: 52px;
  label {
      padding:12px;
      cursor: pointer;
      display: inline-block;
      height:52px;
      width:100%;
  }
}
.toolbar {
  button {
    transform: translateY(-8px);
  }
}
button.trigger {
  font-weight:500 !important;
}
</style>
